import _ from "lodash";
import {
  isMigrationCompletedError,
  isMigrationInProgressError,
  isUnauthorizedError,
  isUnavailableResourceError,
  isUserBlocked,
} from "services/sentry/errors";
import { store } from "store/createStore";
import { setIsPageNotFound, setIsResourceUnavailable } from "modules/Services";
import {
  goToMigrationInProgress,
  goToRootPath,
  goToUserBlockedPage,
} from "modules/NavigationModule";
import { getIsParent } from "modules/CommonSelectors";
import { getUserInfofromStorage } from "services/localStorage";
import {
  setUserIdentityDetails,
  setUserInfoInReduxAndStorage,
  setIsUnmappedParent,
} from "Login/modules/LoginModule";
import { UNAUTHORIZED_ERROR_MESSAGE_STUDENT_ENTITY } from "Constants/stringConstants";

import { persistor } from "lib/apolloClient";

const includedPathsForUnavailableResourceError = ["my-calendar"];

const isPathIncludedForUnavailableResourceError = () => {
  const currentPath = window.location.pathname;
  return _.some(includedPathsForUnavailableResourceError, path =>
    _.includes(currentPath, path)
  );
};

export const globalErrorHandler = errorHandler => {
  const { graphQLErrors, networkError, operation } = errorHandler;

  if (
    isMigrationInProgressError(networkError) ||
    isMigrationCompletedError(networkError)
  ) {
    const isCachePersistenceEnabled = window.__IS_CACHE_PERSISTENCE_ENABLED__;

    //Remove apollo cache data from external storage if migration is in progress
    persistor.pause();
    persistor.purge().then(() => {
      if (isCachePersistenceEnabled) {
        persistor.resume();
      }
    });
  }

  if (isMigrationInProgressError(networkError)) {
    store.dispatch(
      goToMigrationInProgress(_.get(networkError, "result.data", {}))
    );
  } else if (isMigrationCompletedError(networkError)) {
    if (
      _.get(networkError, "result.data.status") === "COMPLETED_TO_CN" ||
      _.get(networkError, "result.data.status") === "COMPLETED_TO_GLOBAL"
    ) {
      store.dispatch(
        goToMigrationInProgress(_.get(networkError, "result.data", {}))
      );
    } else {
      const token = _.get(networkError, "result.data.jwt", "");
      store.dispatch(
        setUserInfoInReduxAndStorage({
          ...getUserInfofromStorage(),
          jwt: token,
          token,
        })
      );
      store.dispatch(goToRootPath());
      store.dispatch(setUserIdentityDetails([]));
      window.location.reload();
    }
  } else if (isUserBlocked(networkError)) {
    const blockedMessage = _.get(
      _.head(_.get(networkError, "result.errors", [])),
      "userMessage",
      ""
    );
    store.dispatch(goToUserBlockedPage({ blockedMessage }));
  }

  graphQLErrors?.forEach(e => {
    const { app_services: { isPageNotFound } = {} } = store.getState();
    if (isUnavailableResourceError(e)) {
      if (!isPageNotFound) {
        if (isPathIncludedForUnavailableResourceError()) {
          store.dispatch(setIsResourceUnavailable(true));
        } else {
          store.dispatch(setIsPageNotFound(true));
        }
      }
    } else if (isUnauthorizedError(e)) {
      const isUnmappedParent =
        getIsParent(store.getState()) &&
        e.message == UNAUTHORIZED_ERROR_MESSAGE_STUDENT_ENTITY;
      if (isUnmappedParent) {
        store.dispatch(setIsUnmappedParent(true));
      }
      store.dispatch(setIsPageNotFound(true));
    }
  });
};
